export const profileEdit = {
  back: '← Back to My Page',
  heading: 'Edit Profile',
  subtitle: 'Edit the fields you want to change',

  // Labels
  nameLabel: 'Name *',
  namePlaceholder: 'A nickname is fine',
  genderLabel: 'Gender',
  countryLabel: 'Country',
  countryPlaceholder: 'Japan',
  timezoneLabel: 'Time zone *',
  nativeLabel: 'Native languages * (multiple allowed)',
  learningLabel: 'Learning languages * (multiple allowed)',

  // Select
  selectPlaceholder: 'Please select',
  genderFemale: 'Female',
  genderMale: 'Male',
  genderOther: 'Other',

  // Validation / states
  validationRequired: 'Please fill in the required fields',
  success: '✅ Saved! Returning to My Page...',
  saving: 'Saving...',
  submit: 'Save changes',
};
